const css = `.lgp1PW__bulletedList{margin-block:0;padding-inline-start:32px;line-height:24px;list-style-type:disc}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"bulletedList":"lgp1PW__bulletedList"};
